// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
var Form__Input = require("../../../uikit/reason/atoms/Form/Form__Input.bs.js");
var SystemMessage = require("../../../uikit/reason/molecules/SystemMessage/SystemMessage.bs.js");
var JsxRuntime = require("react/jsx-runtime");

function Form__Components$TextInputField(props) {
  var errorsFromForm = props.errorsFromForm;
  var validationResult = props.validationResult;
  var fieldStatus;
  var exit = 0;
  if (validationResult !== undefined && validationResult.TAG !== "Ok") {
    fieldStatus = "error";
  } else {
    exit = 1;
  }
  if (exit === 1) {
    fieldStatus = errorsFromForm !== undefined ? "error" : (
        validationResult !== undefined && validationResult._0 === "Valid" ? "ok" : undefined
      );
  }
  var tmp;
  tmp = validationResult !== undefined && validationResult.TAG !== "Ok" ? JsxRuntime.jsx(FormV5.$$Error.make, {
          children: validationResult._0
        }) : null;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(Form__Input.make, {
                      labelText: props.labelText,
                      type: props._type,
                      autocomplete: props.autocomplete,
                      autofocus: props.autofocus,
                      optionalText: props.optionalText,
                      placeholderText: props.placeholderText,
                      onChange: props.onChange,
                      onBlur: props.onBlur,
                      disabled: props.disabled,
                      onFocus: props.onFocus,
                      status: fieldStatus,
                      prepend: props.prepend,
                      append: props.append,
                      value: props.value,
                      id: props.id,
                      inputRef: props.inputRef
                    }),
                tmp,
                errorsFromForm !== undefined ? JsxRuntime.jsx(FormV5.$$Error.make, {
                        children: errorsFromForm
                      }) : null
              ]
            });
}

var TextInputField = {
  make: Form__Components$TextInputField
};

function Form__Components$FieldError(props) {
  var valid = props.valid;
  if (valid === undefined) {
    return null;
  }
  if (typeof valid !== "object") {
    return null;
  }
  if (valid.NAME !== "Error") {
    return null;
  }
  var message = valid.VAL;
  if (message === "") {
    return null;
  } else {
    return JsxRuntime.jsx(FormV5.$$Error.make, {
                children: message
              });
  }
}

var FieldError = {
  make: Form__Components$FieldError
};

function Form__Components$FieldErrorV2(props) {
  var valid = props.valid;
  if (valid === undefined) {
    return null;
  }
  if (valid.TAG === "Ok") {
    return null;
  }
  var message = valid._0;
  if (message === "") {
    return null;
  } else {
    return JsxRuntime.jsx(FormV5.$$Error.make, {
                children: message
              });
  }
}

var FieldErrorV2 = {
  make: Form__Components$FieldErrorV2
};

function Form__Components$FieldErrorAsyncV2(props) {
  var __renderLoadingState = props.renderLoadingState;
  var valid = props.valid;
  var renderLoadingState = __renderLoadingState !== undefined ? __renderLoadingState : (function () {
        return null;
      });
  if (valid === undefined) {
    return null;
  }
  if (valid.TAG === "Validating") {
    return renderLoadingState();
  }
  var message = valid._0;
  if (message.TAG === "Ok") {
    return null;
  }
  var message$1 = message._0;
  if (message$1 === "") {
    return null;
  } else {
    return JsxRuntime.jsx(FormV5.$$Error.make, {
                children: message$1
              });
  }
}

var FieldErrorAsyncV2 = {
  make: Form__Components$FieldErrorAsyncV2
};

function Form__Components$FormStatusMessageV2(props) {
  var dismissSubmissionResult = props.dismissSubmissionResult;
  var resetForm = props.resetForm;
  var onSuccessMessage = props.onSuccessMessage;
  var status = props.status;
  if (typeof status !== "object") {
    if (status === "Editing" || onSuccessMessage === undefined) {
      return null;
    } else {
      return JsxRuntime.jsx(SystemMessage.make, {
                  id: "form_submitted",
                  time: 5000,
                  text: onSuccessMessage,
                  type_: "success",
                  dismissible: true,
                  secondary: true,
                  handleOnDismiss: (function (_id) {
                      resetForm();
                    })
                });
    }
  }
  if (status.TAG === "Submitting") {
    return null;
  }
  var serverMessage = props.submissionErrorToString(status._0);
  if (serverMessage !== undefined) {
    return JsxRuntime.jsx(SystemMessage.make, {
                id: "form_submitted",
                time: 5000,
                text: serverMessage,
                type_: "error",
                dismissible: true,
                secondary: true,
                handleOnDismiss: (function (_id) {
                    dismissSubmissionResult();
                  })
              });
  } else {
    return null;
  }
}

var FormStatusMessageV2 = {
  make: Form__Components$FormStatusMessageV2
};

var View;

var $$Error;

var MediaQuery;

exports.View = View;
exports.$$Error = $$Error;
exports.MediaQuery = MediaQuery;
exports.TextInputField = TextInputField;
exports.FieldError = FieldError;
exports.FieldErrorV2 = FieldErrorV2;
exports.FieldErrorAsyncV2 = FieldErrorAsyncV2;
exports.FormStatusMessageV2 = FormStatusMessageV2;
/* FormV5 Not a pure module */
